export default __webpack_public_path__ + "static/media/html.bff21c24.svg";